/**
 * Collection SEO - Shelf Width Selector + Variant Options + Add to Cart
 */
(function() {
  var variantData = null;
  var configuratorData = null;

  function getVariantData() {
    if (variantData) return variantData;
    var el = document.getElementById('coll-variant-data');
    if (el) {
      try { variantData = JSON.parse(el.textContent); } catch(e) { variantData = {}; }
    }
    return variantData || {};
  }

  function getConfiguratorData() {
    if (configuratorData) return configuratorData;
    var el = document.getElementById('configurator-data');
    if (el) {
      try { configuratorData = JSON.parse(el.textContent); } catch(e) { configuratorData = {}; }
    }
    return configuratorData || {};
  }

  function normalizeFilterValue(value) {
    if (value === null || value === undefined) return '';
    return String(value).trim();
  }

  function setShelfWidth(width) {
    document.querySelectorAll('.shelf-selector__btn').forEach(function(btn) {
      btn.classList.toggle('active', btn.getAttribute('data-width') === String(width));
    });

    var header = document.getElementById('shelf-fit-header');
    if (header) {
      header.textContent = 'Fit Per ' + width + '" Shelf';
    }

    document.querySelectorAll('.coll-size-table .fit-count').forEach(function(cell) {
      var count = cell.getAttribute('data-fit-' + width);
      if (count) {
        cell.textContent = count + ' bins';
      }
    });

    document.querySelectorAll('.card__shelf-fit-badge').forEach(function(badge) {
      var count = badge.getAttribute('data-fit-' + width);
      if (count) {
        badge.textContent = 'Fits ' + count + ' per ' + width + '" shelf';
      }
    });
  }

  /** Update the ($x.xx each) price when variant changes */
  function updateEachPrice(container, priceStr) {
    var eachEl = container.querySelector('.size-card__each');
    if (!eachEl) return;
    var qty = parseInt(eachEl.getAttribute('data-carton-qty'));
    if (!qty || qty <= 0) return;
    var cents = Math.round(parseFloat(priceStr.replace(/[^0-9.]/g, '')) * 100);
    if (isNaN(cents)) return;
    var eachCents = Math.round(cents / qty);
    var dollars = Math.floor(eachCents / 100);
    var remainder = eachCents % 100;
    eachEl.textContent = '($' + dollars + '.' + ('0' + remainder).slice(-2) + ' each)';
  }

  /** Legacy single-dropdown variant change */
  function handleVariantChange(select) {
    var selected = select.options[select.selectedIndex];
    var price = selected.getAttribute('data-price');
    var available = selected.getAttribute('data-available') === 'true';
    var variantId = select.value;

    var container = select.closest('tr') || select.closest('.size-card');
    if (!container) return;

    var imgSrc = selected.getAttribute('data-image');
    if (imgSrc) {
      var img = container.querySelector('.size-table-thumb');
      if (img) img.src = imgSrc;
    }

    var priceCell = container.querySelector('.col-price, .size-card__price');
    if (priceCell) priceCell.textContent = price;

    updateEachPrice(container, price);

    var form = container.querySelector('.size-table-atc');
    if (form) {
      var btn = form.querySelector('.atc-btn');
      btn.setAttribute('data-variant-id', variantId);
      btn.disabled = !available;
      btn.textContent = available ? 'Add to Cart' : 'Sold Out';
    }
  }

  /**
   * Multi-option variant resolution.
   * When any option-select changes, gather all selected options for that product row,
   * find the matching variant, and update price/image/ATC.
   */
  function handleOptionChange(select) {
    var productId = select.getAttribute('data-product-row');
    var container = select.closest('tr') || select.closest('.size-card');
    if (!container) return;

    // Gather all selected option values for this row
    var selects = container.querySelectorAll('.option-select[data-product-row="' + productId + '"]');
    // Also check mobile card options area
    if (selects.length === 0) {
      var card = select.closest('.size-card');
      if (card) {
        selects = card.querySelectorAll('.option-select[data-product-row="' + productId + '"]');
      }
    }

    var data = getVariantData();
    var productData = data[productId];
    if (!productData) return;

    // Build a map of option name -> selected value
    var selectedOptions = {};
    selects.forEach(function(s) {
      selectedOptions[s.getAttribute('data-option-name')] = s.value;
    });

    // Map option names to position indices
    var optionIndices = {};
    productData.options.forEach(function(opt, i) {
      optionIndices[opt.name] = i;
    });

    // Find matching variant
    var match = null;
    for (var i = 0; i < productData.variants.length; i++) {
      var v = productData.variants[i];
      var isMatch = true;
      for (var optName in selectedOptions) {
        var idx = optionIndices[optName];
        if (idx !== undefined && v.options[idx] !== selectedOptions[optName]) {
          isMatch = false;
          break;
        }
      }
      if (isMatch) { match = v; break; }
    }

    if (!match) return;

    // Sync the same product's selects in the OTHER view (desktop/mobile)
    var allSelects = document.querySelectorAll('.option-select[data-product-row="' + productId + '"]');
    allSelects.forEach(function(s) {
      if (s === select) return;
      var name = s.getAttribute('data-option-name');
      if (selectedOptions[name] !== undefined && s.value !== selectedOptions[name]) {
        s.value = selectedOptions[name];
      }
    });

    // Update all containers for this product (desktop row + mobile card)
    var containers = document.querySelectorAll('[data-product-id="' + productId + '"]');
    containers.forEach(function(cont) {
      // Update image
      var img = cont.querySelector('.size-table-thumb');
      if (img) {
        var isDesktop = !!cont.closest('.size-table-desktop');
        img.src = isDesktop ? match.image : match.imageLg;
      }

      // Update price
      var priceCell = cont.querySelector('.col-price, .size-card__price');
      if (priceCell) priceCell.textContent = match.price;

      updateEachPrice(cont, match.price);

      // Update ATC button
      var form = cont.querySelector('.size-table-atc');
      if (form) {
        var btn = form.querySelector('.atc-btn');
        btn.setAttribute('data-variant-id', match.id);
        btn.disabled = !match.available;
        btn.textContent = match.available ? 'Add to Cart' : 'Sold Out';
      }
    });
  }

  function addToCart(form, e) {
    e.preventDefault();
    var btn = form.querySelector('.atc-btn');
    var variantId = btn.getAttribute('data-variant-id');
    var qty = parseInt(form.querySelector('.atc-qty').value) || 1;

    if (!variantId || btn.disabled) return;

    btn.disabled = true;
    var originalText = btn.textContent;
    btn.textContent = 'Adding...';

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: parseInt(variantId), quantity: qty })
    })
    .then(function(res) {
      if (!res.ok) throw new Error('Add to cart failed');
      return res.json();
    })
    .then(function() {
      btn.textContent = 'Added!';
      btn.classList.add('atc-btn--success');
      setTimeout(function() {
        btn.textContent = originalText;
        btn.disabled = false;
        btn.classList.remove('atc-btn--success');
      }, 1500);

      form.dispatchEvent(new CustomEvent('product:added', {
        bubbles: true,
        detail: { button: btn, quantity: qty }
      }));
    })
    .catch(function() {
      btn.textContent = 'Error';
      setTimeout(function() {
        btn.textContent = originalText;
        btn.disabled = false;
      }, 1500);
    });
  }

  function getOptionIndex(productData, optionName) {
    var options = productData.options || [];
    for (var i = 0; i < options.length; i++) {
      if (options[i].name === optionName) return i;
    }
    return -1;
  }

  function productHasSelectedVariantOptions(productData, optionSelections) {
    var optionNames = Object.keys(optionSelections);
    if (optionNames.length === 0) return true;

    var optionIndexes = {};
    for (var i = 0; i < optionNames.length; i++) {
      var index = getOptionIndex(productData, optionNames[i]);
      if (index < 0) return false;
      optionIndexes[optionNames[i]] = index;
    }

    var variants = productData.variants || [];
    for (var v = 0; v < variants.length; v++) {
      var variant = variants[v];
      var matches = true;
      for (var o = 0; o < optionNames.length; o++) {
        var optionName = optionNames[o];
        var selectedValue = optionSelections[optionName];
        var variantValue = normalizeFilterValue((variant.options || [])[optionIndexes[optionName]]);
        if (variantValue !== selectedValue) {
          matches = false;
          break;
        }
      }
      if (matches) return true;
    }

    return false;
  }

  function productMatchesTableFilters(productData, selections) {
    var metafields = productData.metafields || {};
    var metafieldKeys = Object.keys(selections.metafields);
    for (var i = 0; i < metafieldKeys.length; i++) {
      var key = metafieldKeys[i];
      if (normalizeFilterValue(metafields[key]) !== selections.metafields[key]) {
        return false;
      }
    }

    return productHasSelectedVariantOptions(productData, selections.options);
  }

  function collectTableFilterSelections(root) {
    var selections = { metafields: {}, options: {} };
    root.querySelectorAll('[data-filter-chip][aria-pressed="true"]').forEach(function(chip) {
      var type = chip.getAttribute('data-filter-type');
      var key = chip.getAttribute('data-filter-key');
      var value = normalizeFilterValue(chip.getAttribute('data-filter-value'));
      if (!key || !value) return;
      if (type === 'option') {
        selections.options[key] = value;
      } else {
        selections.metafields[key] = value;
      }
    });
    return selections;
  }

  function setProductFilterVisibility(productId, isVisible) {
    document.querySelectorAll('[data-product-id="' + productId + '"]').forEach(function(container) {
      container.classList.toggle('table-filter-hidden', !isVisible);
    });
  }

  function syncVisibleOptionSelects(optionSelections) {
    var optionNames = Object.keys(optionSelections);
    if (optionNames.length === 0) return;

    document.querySelectorAll('.option-select').forEach(function(select) {
      var container = select.closest('[data-product-id]');
      if (!container || container.classList.contains('table-filter-hidden')) return;

      var optionName = select.getAttribute('data-option-name');
      var selectedValue = optionSelections[optionName];
      if (!selectedValue || select.value === selectedValue) return;

      var hasOption = false;
      Array.prototype.forEach.call(select.options, function(option) {
        if (option.value === selectedValue) hasOption = true;
      });

      if (hasOption) {
        select.value = selectedValue;
        handleOptionChange(select);
      }
    });
  }

  function updateTableFilters(root) {
    var data = getConfiguratorData();
    var products = data.products || [];
    var selections = collectTableFilterSelections(root);
    var hasFilters = Object.keys(selections.metafields).length > 0 || Object.keys(selections.options).length > 0;
    var visibleCount = 0;

    products.forEach(function(productData) {
      var isVisible = productMatchesTableFilters(productData, selections);
      if (isVisible) visibleCount++;
      setProductFilterVisibility(productData.id, isVisible);
    });

    syncVisibleOptionSelects(selections.options);

    var countEl = root.querySelector('[data-filter-count]');
    if (countEl) {
      if (!hasFilters) {
        countEl.textContent = 'Showing all ' + products.length + ' models';
      } else {
        countEl.textContent = 'Showing ' + visibleCount + ' of ' + products.length + ' models';
      }
    }

    var clearBtn = root.querySelector('[data-filter-clear]');
    if (clearBtn) clearBtn.hidden = !hasFilters;

    var emptyEl = document.querySelector('[data-filter-empty]');
    if (emptyEl) emptyEl.hidden = visibleCount !== 0;
  }

  function getChipSortValue(chip) {
    var value = normalizeFilterValue(chip.getAttribute('data-filter-value') || chip.textContent);
    var numericValue = parseFloat(value.replace(/[^0-9.]/g, ''));
    if (!isNaN(numericValue)) return numericValue;
    return value.toLowerCase();
  }

  function sortTableFilterChips(root) {
    root.querySelectorAll('.table-filter-chips__values').forEach(function(group) {
      var chips = Array.prototype.slice.call(group.querySelectorAll('[data-filter-chip]'));
      chips.sort(function(a, b) {
        var valueA = getChipSortValue(a);
        var valueB = getChipSortValue(b);
        if (typeof valueA === 'number' && typeof valueB === 'number') return valueA - valueB;
        return String(valueA).localeCompare(String(valueB), undefined, { numeric: true });
      });
      chips.forEach(function(chip) {
        group.appendChild(chip);
      });
    });
  }

  function initTableFilterChips() {
    var root = document.querySelector('[data-table-filter-chips]');
    if (!root) return;

    sortTableFilterChips(root);

    var chips = root.querySelectorAll('[data-filter-chip]');
    chips.forEach(function(chip) {
      chip.addEventListener('click', function() {
        var group = this.closest('[data-filter-group]');
        var wasPressed = this.getAttribute('aria-pressed') === 'true';

        if (group) {
          group.querySelectorAll('[data-filter-chip]').forEach(function(groupChip) {
            groupChip.setAttribute('aria-pressed', 'false');
            groupChip.classList.remove('is-active');
          });
        }

        if (!wasPressed) {
          this.setAttribute('aria-pressed', 'true');
          this.classList.add('is-active');
        }

        updateTableFilters(root);
      });
    });

    var clearBtn = root.querySelector('[data-filter-clear]');
    if (clearBtn) {
      clearBtn.addEventListener('click', function() {
        chips.forEach(function(chip) {
          chip.setAttribute('aria-pressed', 'false');
          chip.classList.remove('is-active');
        });
        updateTableFilters(root);
      });
    }

    updateTableFilters(root);
  }

  document.addEventListener('DOMContentLoaded', function() {
    // Guard against multiple script-tag inclusions (e.g. when both the
    // product-configurator and product-size-table sections are on the page —
    // each includes this script, which would otherwise bind handlers twice).
    if (window.__i4lCollectionSeoInit) return;
    window.__i4lCollectionSeoInit = true;

    // Shelf selector
    document.querySelectorAll('.shelf-selector__btn').forEach(function(btn) {
      btn.addEventListener('click', function() {
        setShelfWidth(parseInt(this.getAttribute('data-width')));
      });
    });

    // Legacy single variant selectors
    document.querySelectorAll('.variant-select').forEach(function(sel) {
      sel.addEventListener('change', function() {
        handleVariantChange(this);
      });
    });

    // Multi-option variant selectors
    document.querySelectorAll('.option-select').forEach(function(sel) {
      sel.addEventListener('change', function() {
        handleOptionChange(this);
      });
    });

    // Add to cart forms
    document.querySelectorAll('.size-table-atc').forEach(function(form) {
      form.addEventListener('submit', function(e) {
        addToCart(this, e);
      });
    });

    initTableFilterChips();
  });

  window.setShelfWidth = setShelfWidth;
})();
